
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Sparkles, Info, Tag, PenLine } from 'lucide-react';
import { useMobileMenu } from './MobileMenuContext';

const MobileNavigationItems = () => {
  const navigate = useNavigate();
  const { closeMenu } = useMobileMenu();

  const handleNavigation = (path: string) => {
    navigate(path);
    closeMenu();
  };

  const mainNavItems = [
    { icon: PenLine, label: 'Write', path: '/write' },
    { icon: Sparkles, label: 'Review My Paper', path: '/upload' },
    { icon: Search, label: 'Explore', path: '/explore' },
    { icon: Tag, label: 'Pricing', path: '/pricing' },
    { icon: Info, label: 'About', path: '/about' },
  ];

  return (
    <div>
      <h3 className="text-sm font-semibold text-muted-foreground mb-3 uppercase tracking-wider">
        Navigation
      </h3>
      <div className="space-y-1">
        {mainNavItems.map((item) => (
          <button
            key={item.path}
            onClick={() => handleNavigation(item.path)}
            className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-muted/50 transition-colors"
          >
            <item.icon className="h-5 w-5 text-muted-foreground" />
            <span className="font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileNavigationItems;
